<template>
<div>
  <header class="mdc-top-app-bar top-app-bar top-header">
		<div class="mdc-top-app-bar__row">
			<section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
				<span class="mdc-top-app-bar__title t-subtitle4 pdl-12 cursor-pointer">{{bradName}}</span>
			</section>
			<section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end" role="toolbar">
				<div class=" t-body2 t-color-white pdr-18 cursor-pointer" @click="login" @keypress="login" tabindex="0">{{$t('3323')}}</div>
			</section>
		</div>
	</header>
	<div class="d-flex h-full flex-column">
		<main class="main-wrapper full flex-grow-1 scroll-y">
			<div class="container container--small pdt-50 ">
				<div class="t-headline11 font-m mgb-8 pdl-24 pdr-24">{{$t('858')}}</div>
				<div class="t-body1 t-color-bodyGrayA font-r mgt-8 pdl-24 pdr-24">{{$t('859')}}</div>
				<div class="mdc-card  mgt-24 mgl-24 mgr-24 mgb-50">
					<div class="pda-24">
						<div class="t-subtitle2 font-m mgb-16">{{$t('860')}}</div>
						<div class="d-flex flex-column">
							<div class="t-body3 t-color-bodyGrayA font-r mgb-2">{{$t('861')}}</div>
							<div class="t-body3 font-r">{{storeTransferData && storeTransferData.granter ? storeTransferData.granter.name:''}}</div>
						</div>
						<div class="d-flex flex-column mgt-19">
							<div class="t-body3 t-color-bodyGrayA font-r mgb-2">{{$t('862')}}</div>
							<div class="t-body3 font-r">{{storeTransferData && storeTransferData.granter ? storeTransferData.granter.address:''}}</div>
						</div>
						<div class="d-flex flex-column mgt-19">
							<div class="t-body3 t-color-bodyGrayA font-r mgb-2">{{$t('1208')}}</div>
							<div class="t-body3 font-r">{{storeTransferData && storeTransferData.granter ? $t(storeTransferData.granter.category.translate):''}}</div>
						</div>
						<div class="d-flex flex-column mgt-19">
							<div class="t-body3 t-color-bodyGrayA font-r mgb-2">{{$t('1209')}}</div>
							<div class="t-body3 font-r">{{storeTransferData && storeTransferData.granter ? storeTransferData.granter.code:''}}</div>
						</div>
						<div class="d-flex flex-column mgt-19">
							<div class="t-body3 t-color-bodyGrayA font-r mgb-2">{{$t('1210')}}</div>
							<div class="t-body3 font-r">{{storeTransferData && storeTransferData.granter ? $t('3437',{first: storeTransferData.granter.represent.first, last: storeTransferData.granter.represent.last}):''}}</div>
						</div>
					</div>
					<div class="divider"></div>
					<div class="pdt-16 pdb-24 pdl-24 pdr-24">
						<div class="t-subtitle2 font-m mgb-16">{{$t('1211')}}</div>
						<div class="d-flex flex-column">
							<div class="t-body3 t-color-bodyGrayA font-r mgb-2">{{$t('1212')}}</div>
							<div class="t-body3 font-r">{{storeTransferData && storeTransferData.grantee?storeTransferData.grantee.name:''}}</div>
						</div>
						<div class="d-flex flex-column mgt-19">
							<div class="t-body3 t-color-bodyGrayA font-r mgb-2">{{$t('1228')}}</div>
							<div class="t-body3 font-r">{{storeTransferData && storeTransferData.grantee?storeTransferData.grantee.address:''}}</div>
						</div>
						<div class="d-flex flex-column mgt-19">
							<div class="t-body3 t-color-bodyGrayA font-r mgb-2">{{$t('1229')}}</div>
							<div class="t-body3 font-r">{{storeTransferData && storeTransferData.grantee?$t(storeTransferData.grantee.category.translate):''}}</div>
						</div>
						<div class="d-flex flex-column mgt-19">
							<div class="t-body3 t-color-bodyGrayA font-r mgb-2">{{$t('1279')}}</div>
							<div class="t-body3 font-r">{{storeTransferData && storeTransferData.grantee?storeTransferData.grantee.code:''}}</div>
						</div>
						<div class="d-flex flex-column mgt-19 mgb-8">
							<div class="t-body3 t-color-bodyGrayA font-r mgb-2">{{$t('1280')}}</div>
							<div class="t-body3 font-r">{{storeTransferData && storeTransferData.grantee?$t('3437',{first: storeTransferData.grantee.represent.first, last: storeTransferData.grantee.represent.last}):''}}</div>
						</div>
					</div>
				</div>
				<div class="mgt-50 mgb-50 pdl-24">
					<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText" @click="callLoginApi" @keypress="callLoginApi" tabindex="0">
						<div class="mdc-button__ripple"></div>
						<span class="mdc-button__label t-body2 font-r">{{$t('1281')}}</span>
					</button>
				</div>
			</div>
		</main>
	</div>
</div>
</template>

<script>
/**
 * 개인정보 취급방침 컴포넌트(Privacy Policy Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCTopAppBar } from "@material/top-app-bar";
import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "@/mixins/topAppBar.js";
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";
import loginApi from "@/api/loginApi.js";
import popupApi from "@/api/popupApi.js";
import firebase from "firebase";
import { userMixin } from "@/mixins/user";

import { mapState, mapMutations } from "vuex";
import localStorageUtil from "@/utils/localStorageUtil";
import memberApi from "@/api/memberApi";

export default {
  components: {
    TopAppBar,
    TopAppBarDrawer
  },
  data() {
    return {
      // title: '개인정보 보호정책',
      bradName: localStorage.getItem('brandName'),
      title: this.$t("1601"),
      params : "",
      redirectPath: "",
      popupData: null,
      popupImage: null,
      socialFirstName: "",
      socialLastName: "",
      socialFullName: "",
      socialEmail: "",
      socialAuth: false,
      isDrawerOpen: false,
      staticMode: '',
      storeTransferData: null,
      isIdpService: localStorageUtil.isIdpServiceValidate()
    };
  },

  mixins: [topAppBarMixin,userMixin],

  mounted() {
    this.params = JSON.parse(localStorage.getItem("userParams"));
    this.topAppBar = MDCTopAppBar.attachTo(
      document.querySelector(".mdc-top-app-bar")
    );
    this.setTopAppBarCloseOnly(localStorage.getItem("brandName"));
    let loginAuth = this.isIdpService ? loginApi.authToken() : loginApi.authCheck()
    loginAuth.then((response) => {
      console.log('loginApi.authToken => ', response.data.data)
        this.storeTransferData = response.data.data.storeTransfer;
      }).catch((error)=>{ console.log('error=>', error)})
  },

  computed: {
    selectedTabBar() {
      return this.$route.meta.TabType;
    },
  },

  methods: {
    ...mapMutations("join", [
      "SET_JOINSTART",
      "SET_SOCIAL_LINK",
			"SET_PUSH_NOTIFICATION",
      "SET_NAME_FIRST",
      "SET_NAME_LAST",
      "SET_NAME_FULL",
      "SET_LOGINID",
      "SET_SOCIAL_ID",
      "INIT_JOIN_STORE",
    ]),

    ...mapMutations("dormancy", ["MUTATION_USER_DATA"]),

    openDrawer() {
      this.isDrawerOpen = true;
    },
    // Close drawer
    closeDrawer() {
      this.isDrawerOpen = false;
    },

    login() {
      if (this.isIdpService) {
        this.$moveIdpLogout();
      } else {
        this.$router.push("/login");
      }
    },

    callLoginApi() {
      let paramss = this.params;
      loginApi.checkStoreTransfer(paramss)
            .then(res => {
              let loginAuth = this.isIdpService ? loginApi.authToken() : loginApi.authCheck()
              loginAuth.then((response) => {
                  let responseData = response.data.data;
                  if (this.isIdpService) {
                    loginApi.setAuthInHeader(responseData.token);
                  }
                  this.MUTATION_USER_DATA(responseData);
                  this.checkUser();
                })
                .catch((err) => {
                  const responseData = err.response.data.meta;
                  if (responseData.errCode === 1201) {
                    // 관리자 승인 대기중(Waiting for administrator approval)
                    // 매장 관리자 승인 대기중 입니다. 관리자에게 문의해주세요.
                    // this.$snackOpen({contents: 'Todo 관리자 승인 대기중 입니다. 관리자에게 문의해주세요.', btnDisplayYN: false}).then(() => {})

                    this.$alert({
                      title: this.$t("779"), //가입 승인 대기 상태입니다.
                      content:
                        this.$t("780") +
                        "<br>" +
                        this.$t("781", {
                          str:
                            '<a href="mailto:' +
                            BRAND_MANAGER_EMAIL +
                            '">' +
                            BRAND_MANAGER_EMAIL +
                            "</a>",
                        }) +
                        "<br>" +
                        this.$t("782", {
                          str:
                            '<a href="tel:' +
                            BRAND_MANAGER_PHONE +
                            '">' +
                            BRAND_MANAGER_PHONE +
                            "</a>",
                        }),
                      accept: this.$t("783"),
                    })
                      .then(() => {})
                      .catch(() => {});
                  } else if (responseData.errCode === 1202) {
                    this.$alert({
                      title: this.$t("779"), //가입 승인 대기 상태입니다.
                      content:
                        this.$t("780") +
                        "<br>" +
                        this.$t("781", {
                          str:
                            '<a href="mailto:' +
                            BRAND_MANAGER_EMAIL +
                            '">' +
                            BRAND_MANAGER_EMAIL +
                            "</a>",
                        }) +
                        "<br>" +
                        this.$t("782", {
                          str:
                            '<a href="tel:' +
                            BRAND_MANAGER_PHONE +
                            '">' +
                            BRAND_MANAGER_PHONE +
                            "</a>",
                        }),
                      accept: this.$t("783"),
                    })
                      .then(() => {})
                      .catch(() => {});
                  } else if (responseData.errCode === 1204) {
                    this.$alert({
                      title: this.$t("1482"), //가입 승인 대기 상태입니다.
                      content:
                        this.$t("1483") +
                        "<br>" +
                        this.$t("1484") +
                        ": " +
                        '<a href="mailto:' +
                        BRAND_MANAGER_EMAIL +
                        '">' +
                        BRAND_MANAGER_EMAIL +
                        "</a>" +
                        "<br>" +
                        this.$t("1485") +
                        ": " +
                        '<a href="tel:' +
                        BRAND_MANAGER_PHONE +
                        '">' +
                        BRAND_MANAGER_PHONE +
                        "</a>",
                      accept: this.$t("1486"),
                    })
                      .then(() => {})
                      .catch(() => {});
                  } else if (responseData.errCode === 1205) {
                    this.$alert({
                      title: this.$t("1914"), //가입 승인 대기 상태입니다.
                      content:
                        this.$t("1915") +
                        " " +
                        this.$t("1916") +
                        "<br>" +
                        this.$t("1917", {
                          str:
                            '<a href="mailto:' +
                            BRAND_MANAGER_EMAIL +
                            '">' +
                            BRAND_MANAGER_EMAIL +
                            "</a>",
                        }) +
                        "<br>" +
                        this.$t("1918", {
                          str:
                            '<a href="tel:' +
                            BRAND_MANAGER_PHONE +
                            '">' +
                            BRAND_MANAGER_PHONE +
                            "</a>",
                        }),
                      accept: this.$t("1919"),
                    })
                      .then(() => {})
                      .catch(() => {});
                  } else if (responseData.errCode === 1105) {
                    this.$alert({
                      content: this.$t("1875"),
                      accept: this.$t("1876"),
                    })
                      .then(() => {})
                      .catch(() => {});
                  } else if (responseData.errCode === 1335) {
                    //아이디 계정 일시 정지(Suspend Account)
                    // 로그인 정보가 5회 이상 일치하지 않아 30분간 로그인 정지되었습니다. 30분 후 다시 시도해주세요.
                    this.$snackOpen({
                      contents: this.$t("323"),
                      btnDisplayYN: false,
                    }).then(() => {});
                  } else {

                  }
                });
            })
            .catch(err => console.log("STORE TRANSFER ERROR : ", err))
      
    },
    signOutFirebase() {
        firebase.auth().signOut();
    },
  },
};
</script>
